import { Component, OnInit } from '@angular/core';
import { NavController,IonRouterOutlet } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import { GlobalVars } from '../../../../../providers/globalVars';

@Component({
  selector: 'app-sender',
  templateUrl: './sender.page.html',
  styleUrls: ['./sender.page.scss'],
})
export class SenderPage implements OnInit {
  pn:number=0;
  cangoback:boolean = false;
  uid:any;
  constructor(private navCtrl:NavController,private outlet: IonRouterOutlet,
  private gv:GlobalVars
  ,private afDB: AngularFireDatabase,private afAuth: AngularFireAuth) { }

  close(){
    if(this.cangoback) this.navCtrl.pop()
    else this.navCtrl.navigateBack('/'); 
  }
  
  ngOnInit() {
    this.cangoback = this.outlet && this.outlet.canGoBack();
    if(this.gv.uid){
      this.uid = this.gv.uid;
    }
    else
      this.close();
  }

  submit(){
    this.afDB.database.ref('/servicelist/forex/' + this.uid + '/userdata/identified').set(true).then(_=>
      this.close()
    )}

}
